export default "__VITE_ASSET__00497eba__"